// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Order_item_requests_VerificarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/order_item_requests/verificar
 *
 * Mark a customer request as verified. The id arrives as a URI segment, not in the body,
 * so this contract is minimal — it enforces that no extra raw body parsing happens in the controller.
 */
import { registerContract } from './validate'

export interface Order_item_requests_VerificarInput {}

registerContract('Order_item_requests_VerificarInput', {})
